import React, { useCallback, useState, useEffect } from "react";
import Toast from "../LoadingError/Toast";
import { Link } from "react-router-dom";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import MainPanel from "../main-panel/MainPanel";
import moment from "moment/moment";
import { BLOG_UPDATE_RESET } from "../../Redux/Constants/BlogConstants";
import { BASE_URL, PICTURE_URL } from "../../api/BaseConfig";

import {
  blogEditAction,
  blogUpdateAction,
} from "../../Redux/Actions/BlogAction";
import axios from "axios";
import { Box, Button, Checkbox, FormControl, FormLabel, Heading, Image, Input } from "@chakra-ui/react";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};

const EditBlogMain = (props) => {
  const { blogId } = props;
  let DefaultLanguageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];



  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [photoUrl, setPhotoUrl] = useState([]);
  const [isFeatured, setIsFeatured] = useState(false);
  const [language, setLanguage] = useState([]);
  const [imageTitle, setImageTitle] = useState("");
  const [imageAlt, setImageAlt] = useState("");
  const dispatch = useDispatch();

  const handlePicture = async (e) => {
    const file = e.target.files[0]; 
    if (!file) return;
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      const { data } = await axios.post(`${BASE_URL}/file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setPhotoUrl(data);
    } catch (error) {
      toast.error("Failed to upload image", ToastObjects);
    }
  };

  const onHandleLangChange = useCallback(
    (dataInfo) => {
      let languageList = {
        blogId: parseInt(blogId),
        id: parseInt(dataInfo.id),
        name: dataInfo.name,
        description: dataInfo.description,
        seoTitle: dataInfo.seoTitle,
        seoDescription: dataInfo.seoDescription,
        languageKey: dataInfo.lang,
      };
      setLanguage((ln) => [
        ...ln.filter(
          (l) => l.languageKey !== dataInfo.lang && l.languageKey !== "" && typeof (l.languageKey) != 'undefined'
        ),
        languageList,
      ]);
    },
    [blogId]
  );



  const blogEdit = useSelector((state) => state.blogEdit);
  const { loading, error, blog } = blogEdit;

  const blogUpdate = useSelector((state) => state.blogUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = blogUpdate;



  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: BLOG_UPDATE_RESET });
      toast.success("Blog Updated", ToastObjects);
    } else {
      if (!blog || blog.id !== parseInt(blogId)) {
        dispatch(blogEditAction(blogId));
      } else {
        setLanguage(blog.blogRecords);
        setIsFeatured(blog.isFeatured);
        setPhotoUrl(blog.photoUrl);
        setImageTitle(blog.imageTitle || "");
        setImageAlt(blog.imageAlt || "");
        setDate(moment(blog.blogDate).format("YYYY-MM-DD"));
      }
    }
  }, [blog, dispatch, blogId, successUpdate]);


  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      blogUpdateAction({
        id: blogId,
        blogDate: date,
        photoUrl,
        imageTitle,
        imageAlt,
        blogRecords: language.filter((l) => l.languageKey !== "" && typeof (l.languageKey) != 'undefined'),
      })
    );
  };

  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={4}>
        <form onSubmit={submitHandler}>
          <div className="content-header" style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              as={Link}
              to="/blogs"
              colorScheme="red"
              variant="solid"
              _hover={{
                backgroundColor: "red.600",
                color: "white",
              }}
            >
              Go to blogs
            </Button>
            <Heading as="h2" size="lg" color="teal.600">
              Update Blog
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </div>
          <Box mt={4}>
            <Box className="card mb-4 shadow-sm" borderRadius="md" boxShadow="lg" p={5}>
              {errorUpdate && <Message variant="alert-danger">{errorUpdate}</Message>}
              {loadingUpdate && <Loading />}
              {loading ? (
                <Loading />
              ) : error ? (
                <Message variant="alert-danger">{error}</Message>
              ) : (
                <>
                  <MainPanel
                    mainLang={DefaultLanguageList}
                    languageInfo={language}
                    changeLang={onHandleLangChange}
                  />
                  <FormControl mb={4}>
                    <FormLabel htmlFor="blog_date">Date</FormLabel>
                    <Input
                      type="date"
                      id="blog_date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel htmlFor="blog_featured">Is Featured?</FormLabel>
                    <Checkbox
                      id="blog_isFeatured"
                      isChecked={isFeatured}
                      onChange={(e) => setIsFeatured(e.target.checked)}
                    >
                      Featured
                    </Checkbox>
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel>Images</FormLabel>
                   <Input type="file" onChange={handlePicture} />
                    {photoUrl && (
                      <Box
                        mt={3}
                        width="300px"
                        height="250px"
                        overflow="hidden"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        bgcolor="lightgray" 
                      >
                        <Image
                          src={PICTURE_URL + photoUrl}
                          alt="Uploaded Image"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                          }}
                        />
                      </Box>
                    )}

                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel htmlFor="image_title">Image Title</FormLabel>
                    <Input
                      type="text"
                      id="image_title"
                      value={imageTitle}
                      onChange={(e) => setImageTitle(e.target.value)}
                      placeholder="Enter image title"
                    />
                  </FormControl>
                  <FormControl mb={4}>
                    <FormLabel htmlFor="image_alt">Image Alt Text</FormLabel>
                    <Input
                      type="text"
                      id="image_alt"
                      value={imageAlt}
                      onChange={(e) => setImageAlt(e.target.value)}
                      placeholder="Enter image alt text"
                    />
                  </FormControl>
                </>
              )}
            </Box>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default EditBlogMain;